import { platformApiFetch } from '@/services/platformApi/client';
import { debugLogger } from '@/utils/debug';
import { ProfileData } from '@/types/supabase';

export interface SubscriptionUpsertInput {
  email: string;
  user_id?: string | null;
  tier: string;
}

interface ServiceResult<T = undefined> {
  success: boolean;
  error?: string;
  data?: T;
}

interface ExistingSubscriberRow {
  id: string;
  email: string;
  user_id: string | null;
}

export async function upsertSubscription(input: SubscriptionUpsertInput): Promise<ServiceResult> {
  try {
    return await platformApiFetch<ServiceResult>('/v1/subscriptions/admin/upsert', {
      method: 'POST',
      body: JSON.stringify(input),
    });
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : 'Unknown error';
    debugLogger.log('subscriptionAdminService.upsert error', message);
    return { success: false, error: message };
  }
}

export async function listUsersForSubscription(): Promise<ServiceResult<ProfileData[]>> {
  try {
    return await platformApiFetch<ServiceResult<ProfileData[]>>('/v1/subscriptions/admin/users');
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : 'Failed to fetch users';
  return { success: false, error: message, data: [] as ProfileData[] };
  }
}
